import React, { Fragment } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";
import BlogBanner from './blog-banner';
import LatestBlog from './latest-blog';
import BlogList from './blog-lists'; 

function BlogPage () {
    return(
      <Fragment> 
      <Header />  
      <BlogBanner /> 
      <LatestBlog />    
      <BlogList />  
      <Footer /> 
      </Fragment> 
    );
}
export default BlogPage;